import React from "react";
import { ChevronRight } from "lucide-react";
import { Link } from "react-router-dom";

export function Breadcrumb({ items }) {
  return (
    <nav
      className="flex items-center flex-wrap gap-1.5 text-sm text-slate-500 mb-5"
      data-testid="breadcrumb"
    >
      {items.map((it, i) => {
        const last = i === items.length - 1;
        return (
          <React.Fragment key={i}>
            {it.to && !last ? (
              <Link
                to={it.to}
                data-testid={`breadcrumb-${i}`}
                className="hover:text-[#E2333F] transition-colors font-medium"
              >
                {it.label}
              </Link>
            ) : (
              <span
                data-testid={`breadcrumb-${i}`}
                className={last ? "text-[#E2333F] font-bold" : "font-medium"}
              >
                {it.label}
              </span>
            )}
            {!last && <ChevronRight className="w-3.5 h-3.5 text-slate-300" />}
          </React.Fragment>
        );
      })}
    </nav>
  );
}

export function KpiBanner({ stats }) {
  return (
    <div
      className="flex flex-wrap bg-white border border-slate-200 rounded-sm shadow-sm mb-6 overflow-hidden"
      data-testid="kpi-banner"
    >
      {stats.map((s, i) => (
        <div
          key={i}
          className="flex-1 min-w-[160px] px-5 py-4 border-r border-slate-100 last:border-r-0"
        >
          <div className="text-[11px] uppercase tracking-wider text-slate-400 font-semibold mb-1">
            {s.label}
          </div>
          <div className="font-display font-black text-2xl text-slate-900 leading-none">
            {s.value}
          </div>
          {s.sub && <div className="text-xs text-slate-400 mt-1">{s.sub}</div>}
        </div>
      ))}
    </div>
  );
}

export function PageTitle({ eyebrow, title, subtitle, badge }) {
  return (
    <div className="mb-6">
      {eyebrow && (
        <div className="text-[11px] uppercase tracking-[0.2em] text-[#E2333F] font-bold mb-1">
          {eyebrow}
        </div>
      )}
      <div className="flex items-center gap-3 flex-wrap">
        <h1 className="font-display font-black text-3xl sm:text-4xl tracking-tight text-slate-900">
          {title}
        </h1>
        {badge}
      </div>
      {subtitle && <p className="text-slate-500 text-sm mt-1.5">{subtitle}</p>}
    </div>
  );
}
